<template>
  <a v-if="showInfo && message != ''" :href="link" class="labels no-shipping-info">{{ message }}</a>
</template>

<script>
export default {
  selector: "#vue-no-shipping-info",
  props: {
    countries: {
      type: Array,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      userCountry: "",
      showInfo: false
    };
  },
  watch: {
    userCountry(newVal) {
      if (newVal != "") {
        if (!this.countries.includes(newVal)) {
          this.showInfo = true;
        }
      }
    }
  },
  methods: {
    async getUserCountry() {
      const { data } = await this.$http.get("https://ipapi.co/json/");
      this.userCountry = data.country_code;
    }
  },
  mounted() {
    this.getUserCountry();
  }
};
</script>

<style lang="scss" scoped>
a {
  display: block;
  margin-bottom: 15px;
  color: inherit;
  text-decoration: none;
  transition: all 0.2s ease-in;
  cursor: pointer;

  &:hover {
    color: #979797;
  }
}
</style>
